/**
 * Enumeration for HTTP endpoints related to ticket events.
 * Contains routes used for ticket event operations.
 */
export enum HTTP_TICKET_EVENTS_EVENT {
  /**
   * Endpoint for updating ticket events
   */
  updateTicketEvent = '/api/ticket-events/update'
}
